import React, { useEffect, useRef, useState } from "react";
import CheckBox from "@mnjsplatform/components/lib/common/InputField/CheckBox";
import { MnCheckbox } from "@mnjsplatform/components/lib/common/InputField/MnCheckbox";
import i18next from "i18next";

export const TabNumberSwitcher = ({checked, onChange}) => {

  const width = 55;
  const height = 30;
  const switcherSize = height - 2;
  const localstorageName = 'testTabNumber';

  const activeColor = (checked ? "#039c3c" : "#659ec8");
  const containerBaseStyle = {width: `${width}px`, minWidth: `${width}px`, height: `${height}px`,border: ('1px solid' + activeColor), borderRadius: `${height/2}px`};
  const containerClass = "d-flex c-pointer justify-content-" + (checked ? 'end' : "start");
  const switcherBaseStyle = {width: `${switcherSize}px`, height: `${switcherSize}px`,border: '1px #ccc solid', borderRadius: `${switcherSize/2}px`, background: activeColor};
  const iconStyle = {fontSize: '18px', color: '#fff'};

  const tabNumberRef = useRef(null);
  const saveTabNumberRef = useRef(null);

  const localstorageValue = localStorage.getItem(localstorageName);
  const [tabNumberValue, setTabNumberValue] = useState(localstorageValue);
  const [saveTabNumber, setSaveTabNumber] = useState(!!localstorageValue);

  useEffect(() => {
    if (checked) update();
  }, [checked]);

  useEffect(() => {
    if (!saveTabNumber) {
      localStorage.removeItem(localstorageName);
    } else {
      localStorage.setItem(localstorageName, tabNumberValue);
    }
  }, [saveTabNumber, tabNumberValue]);

  const toggle = () => {
    onChange({tabNumber: null, checked: !checked});
  }

  const update = () => {
    const number = checked ? tabNumberValue : null;
    onChange({tabNumber: number, checked: checked});
  }

  const keyUpHandler = (e) => {
    if(e.key === "Enter") {
      update();
    }
  }

  const onValueChangeHandler = () => {
    const number = tabNumberRef?.current?.value;
    setTabNumberValue(number);
  }

  const onCheckHandler = () => {
    const isChecked = saveTabNumberRef?.current?.checked;
    setSaveTabNumber(isChecked);
  }

  return (
    <>
      <div className={containerClass} style={containerBaseStyle} onClick={toggle}>
        <div className={"d-flex justify-content-center"} style={switcherBaseStyle}>
          <i className="zmdi zmdi-account" style={iconStyle}></i>
        </div>
      </div>
      {checked &&
        <>
          <div className={"d-flex border ml-2"} style={{ height: `${height}px`, "minWidth": "120px" }}>
            <input type={"text"} placeholder={i18next.t('TabNum_Label')} autoFocus={true} ref={tabNumberRef}
                   onKeyUp={keyUpHandler} value={tabNumberValue || ""} onChange={onValueChangeHandler} />
            <i className="zmdi zmdi-caret-right-circle align-middle mt-auto mb-auto mr-1 c-pointer"
               style={{color: "#17b169", fontSize: "25px"}} onClick={update}></i>
          </div>
          <label htmlFor={"tabNumberRemember"} className={"d-flex ml-2 align-middle c-pointer"}>
            <input type={"checkbox"} className={"c-pointer"} id={"tabNumberRemember"} onChange={onCheckHandler}
                   ref={saveTabNumberRef} checked={saveTabNumber} />
            &nbsp;
            <div className={"align-middle m-auto"}>{i18next.t('Remember')}</div>
          </label>
        </>
      }
    </>
  )
}